export default __webpack_public_path__ + "static/media/autoreview.e1184739.jpg";